import React, { useState } from 'react';
import {EuiButton, EuiHeader, EuiHeaderSection, EuiHeaderSectionItem, EuiHeaderLogo, EuiHeaderLinks, EuiHeaderLink, EuiHeaderSectionItemButton, EuiIcon, EuiCollapsibleNavGroup, EuiListGroup, EuiListGroupItem, EuiPage, EuiPageBody } from '@elastic/eui';
import { useNavigate } from 'react-router-dom';
import './Layout.css';

interface LayoutProps {
    children: React.ReactNode;
    role: string;
}
const Layout: React.FC<LayoutProps> = ({ children,role })=> {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [isDistributor,setUserRole] = useState<boolean>(()=>{if(role=="DISTRIBUTOR"){ return true}else {return false}})
    const history = useNavigate();

    const handleLogout = () => {
       
        localStorage.removeItem('token');
        
        window.location.href = '/login';
    };

    const handleSidebarItemClick = (route: string) => {
        history(route)
    };

    return (
        <div className="layout">


            <EuiPage>
                <div className="sidebar">
                    <EuiCollapsibleNavGroup
                        title="Menu"

                        isCollapsible={true}
                        initialIsOpen={isSidebarOpen}
                        paddingSize="l"
                    >
                        <EuiListGroup flush={true}>
                            <EuiListGroupItem iconType="user" label="Profile" onClick={() => handleSidebarItemClick('/home')} />
                            <EuiListGroupItem iconType="folderCheck" label="Manage Pin" onClick={() => handleSidebarItemClick('/manage-pin')} />
                            { isDistributor && <EuiListGroupItem iconType="users" label="Seller" onClick={() => handleSidebarItemClick('/manage-seller')} />}
                            <EuiListGroupItem iconType="creditCard" label="Credit" onClick={() => handleSidebarItemClick('/creditmenu')} />
                            <EuiListGroupItem iconType="payment" label="Payment" onClick={() => handleSidebarItemClick('/payment')} />
                        </EuiListGroup>

                        <div className="logoutButton">
                            <EuiButton fullWidth onClick={handleLogout}>Logout</EuiButton>
                        </div>
                    </EuiCollapsibleNavGroup>
                </div>

                <EuiPageBody>
                    {children}
                </EuiPageBody>
            </EuiPage>
        </div>
    );
};

export default Layout;